<div class="swiper-outer">
  <div
    class="pb-5 w-full overflow-hidden"
    [style.--swiper-template-count]="templates.length"
    [style.--swiper-index]="index"
    [style.--swiper-offset]="offset + 'px'"
  >
    <div
      class="swiper-inner-container"
      [class.swiping]="swiping"
      libSwipe
      [swipeMode]="'horizontal'"
      (onSwipe)="onSwipe($event)"
      (onChangeOffset)="offset = $event.x"
      (onSwipeEvent)="swipeEvent($event)"
    >
      @for (tpl of templates; track tpl; let i = $index) {
        <div class="swiper-item px-5" [style.width]="100 / templates.length + '%'">
          <ng-content />
          <!-- please don't remove this: https://github.com/angular/angular/issues/50543 -->
          <ng-container [ngTemplateOutlet]="tpl"></ng-container>
        </div>
      }
    </div>
  </div>
  @if (templates.length > 1 && numberOfDots > 1) {
    <div class="dots pb-5">
      @for (t of templates; track t; let i = $index) {
        <div class="dot" [class.active]="index === i" (click)="index = i"></div>
      }
    </div>
  }
  @if (!hideArrows && templates.length > 1 && numberOfDots > 1) {
    <div class="arrows">
      <div class="arrow left" [class.disabled]="index === 0" (click)="onSwipe('left')"></div>
      <div
        class="arrow right"
        [class.disabled]="index === numberOfDots - 1"
        (click)="onSwipe('right')"
        data-testid="swiper-right-arrow"
      ></div>
    </div>
  }
</div>
